import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useOrder } from "../context/OrderContext.jsx";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export default function SignupPage() {
  const navigate = useNavigate();
  const { order, setOrder } = useOrder();

  // Pre-fill if the user came back from the payment page.
  const [name, setName] = useState(order?.name ?? "");
  const [email, setEmail] = useState(order?.email ?? "");
  const [amount, setAmount] = useState(
    order?.amount != null ? String(order.amount) : "",
  );
  const [errors, setErrors] = useState({});

  function validate() {
    const next = {};
    if (name.trim().length === 0) {
      next.name = "Name is required.";
    }
    if (!EMAIL_RE.test(email.trim())) {
      next.email = "Enter a valid email address.";
    }
    const parsed = Number(amount);
    if (amount.trim().length === 0 || Number.isNaN(parsed) || parsed <= 0) {
      next.amount = "Enter an amount greater than 0.";
    }
    setErrors(next);
    return Object.keys(next).length === 0;
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (!validate()) return;

    setOrder({
      name: name.trim(),
      email: email.trim(),
      amount: Number(amount),
    });
    navigate("/payment");
  }

  return (
    <section className="card">
      <h2 className="card__title">Sign up</h2>
      <p className="card__subtitle">Enter your details to continue to payment.</p>

      <form className="form" onSubmit={handleSubmit} noValidate>
        <label className="field">
          <span className="field__label">Name</span>
          <input
            className="field__input"
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder="Jane Investor"
            autoComplete="name"
          />
          {errors.name && <small className="field__error">{errors.name}</small>}
        </label>

        <label className="field">
          <span className="field__label">Email</span>
          <input
            className="field__input"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="jane@example.com"
            autoComplete="email"
          />
          {errors.email && (
            <small className="field__error">{errors.email}</small>
          )}
        </label>

        <label className="field">
          <span className="field__label">Amount (USD)</span>
          <input
            className="field__input"
            type="number"
            min="0"
            step="0.01"
            value={amount}
            onChange={(event) => setAmount(event.target.value)}
            placeholder="100.00"
            inputMode="decimal"
          />
          {errors.amount && (
            <small className="field__error">{errors.amount}</small>
          )}
        </label>

        <button className="btn" type="submit">
          Continue to payment
        </button>
      </form>
    </section>
  );
}
